import { render } from "./MoveEdit.vue?vue&type=template&id=0a797219&scoped=true&ts=true"
import script from "./MoveEdit.vue?vue&type=script&lang=ts"
export * from "./MoveEdit.vue?vue&type=script&lang=ts"

import "./MoveEdit.vue?vue&type=style&index=0&id=0a797219&scoped=true&lang=scss"

import exportComponent from "/Users/goyuntae/Desktop/bucket-list/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a797219"]])

export default __exports__